import { default as _91_46_46_46slug_93kJWZg7odbZMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/[...slug].vue?macro=true";
import { default as indexdXqcWlqw7jMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/auth/index.vue?macro=true";
import { default as index6CCU2KrH1GMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93Nh3ZtIkyiVMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_934UqVI3srdCMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93UEe7lbsZ1nMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93r7NQTMMpktMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/news/[slug].vue?macro=true";
import { default as organisationscDFkXjnwsDMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventsjC6icMiLlFMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programsiV2VabiUcCMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexyKlg2jdkAMMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/processes/index.vue?macro=true";
import { default as dungeontfjIzlhDRYMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputs3ZstwchpGUMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexcIZE0smwrOMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/secret/index.vue?macro=true";
import { default as indexONVP9uSqRGMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDataYzILhX0EtCMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassjbJLxm3WmcMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93GSvvSXATQwMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexFn6zVYWD8RMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataAYGkMoOWuCMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldsLkuJvCRgJ0Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportseAWL3vtzisMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsLvAPL3xl1XMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93vBQWuB8VWEMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexUbHfGpSfPhMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesuJGP0kWjNQMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDatae3Dqyk4CpMMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93ZU7ob1kqCmMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as index7heGZgQkPfMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitieszfT1V6bEL3Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDatazixFNCnZm3Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93HU3F0i53RqMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexDFmhN2RK0SMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDataBMg1Yg4m7MMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93EH0GT3PIHSMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexNOkzVsT6eIMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDataMJb42GiXUYMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassqjVrySf9RWMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormsVPjn2EunqOMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_93aXkpAMscVWMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexcc1VVAQuwDMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitieseXxK4jvWbQMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDataoXTzjB6OlpMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodsBNTsFch7hzMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as _91id_934N7lYTIyvKMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as index1c8i516cTNMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivities09omFwmnebMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDataDSBWZy4hNvMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsZtJibWEImWMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93wyZ6y28BQYMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexRzgRJsONSNMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataSvHKourJTlMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearData9fBGgtkMvXMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_9362BBCSfSlaMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexkaB0mz9YxXMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDatap6eXpKaiT0Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93T2DeOVIDHpMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexkECViExyuxMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroupsJPotWIR8yqMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDatajrKtIM0EMkMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93aOGZg5klGwMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexyRmLB49rXZMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesVshr7U3lZtMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesM2NMbVGYy5Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsmG8jt2BqPLMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDataFwKmfZFvnIMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiasNhjDdsH6iyMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishes3zJbKR7AElMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93CAJydGaS5dMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexprjtOBKTwjMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionsU23q2XemELMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehlt0RVJ66psFUMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseData4By9f9q5ckMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsLcD35FQLc6Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93mhSQAnxAwiMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexZcpZtEuFPBMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsTn4gBbEsixMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesarwgr7q1lyMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseData1etW1244HEMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93jSuQb1H7r2Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/processes/[id].vue?macro=true";
import { default as indexOIFZ6B8NHDMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/processes/index.vue?macro=true";
import { default as _91id_938C1DKilxuNMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexrBIzCqp7KoMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersnBqkNiSTrLMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesiw5TxvDMJJMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingsGDSormXZ0KMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseData80XjctGjbbMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategories3gcBqLOF2DMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConceptGI7m4yGVq9Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementKulfHf6sO8Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUserseaNNbSAYl2Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93weqMAB9felMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexcHZ16BD5sjMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisations5l3UcJMBtPMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesveaGxq8pArMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDatau3wwz4ZFYFMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureKlwA1Kh3cnMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93zRGmOYykm6Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexFgYIMgzTArMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/users/index.vue?macro=true";
import { default as userszJpfjVEljWMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/users.vue?macro=true";
import { default as settingsPQ0lrVRIWUMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesdtGFGq1LMOMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDataElz2ZC71gKMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93gtiBMCn8zWMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexrVPjn9efxJMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as servicekZaPVkFnOMMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service.vue?macro=true";
import { default as language6fLSICeLj6Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDatazXuX8777dPMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesNYOkbQxZNPMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementdaleGudvw6Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersXdkE1Dyl5lMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93lhU0yWHSh5Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDataBPJp1Zv62rMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignaturepg2pvcU2TPMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93mavfE0pcPgMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/users/[id].vue?macro=true";
import { default as indexR9fAHWd7wLMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/users/index.vue?macro=true";
import { default as settingswwsCsWX8lYMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings.vue?macro=true";
import { default as signaturetw6BpqhJs3Meta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/signature.vue?macro=true";
import { default as sportbizzviQS6NAe9YMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93QUy1L1SZqyMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93SdPXusSVZpMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexiVWTfF0QbsMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93oGGeeH4CUlMeta } from "/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93kJWZg7odbZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexdXqcWlqw7jMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: index6CCU2KrH1GMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93Nh3ZtIkyiVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_934UqVI3srdCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93UEe7lbsZ1nMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationscDFkXjnwsDMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexyKlg2jdkAMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: servicekZaPVkFnOMMeta?.name,
    path: "/service",
    meta: servicekZaPVkFnOMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDatap6eXpKaiT0Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexONVP9uSqRGMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93GSvvSXATQwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexFn6zVYWD8RMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93vBQWuB8VWEMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexUbHfGpSfPhMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93ZU7ob1kqCmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: index7heGZgQkPfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93HU3F0i53RqMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexDFmhN2RK0SMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93EH0GT3PIHSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexNOkzVsT6eIMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_93aXkpAMscVWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexcc1VVAQuwDMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_934N7lYTIyvKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: index1c8i516cTNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93wyZ6y28BQYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsZtJibWEImWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexRzgRJsONSNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_9362BBCSfSlaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexkaB0mz9YxXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93T2DeOVIDHpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesVshr7U3lZtMeta?.name,
    path: "parishes",
    meta: parishesVshr7U3lZtMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93aOGZg5klGwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionsU23q2XemELMeta?.name,
    path: "regions",
    meta: regionsU23q2XemELMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93CAJydGaS5dMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsTn4gBbEsixMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93mhSQAnxAwiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexZcpZtEuFPBMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93jSuQb1H7r2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexOIFZ6B8NHDMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/processes/index.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsPQ0lrVRIWUMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersnBqkNiSTrLMeta?.name,
    path: "loginProviders",
    meta: loginProvidersnBqkNiSTrLMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_938C1DKilxuNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexrBIzCqp7KoMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisations5l3UcJMBtPMeta?.name,
    path: "organisations",
    meta: organisations5l3UcJMBtPMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93weqMAB9felMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexcHZ16BD5sjMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: userszJpfjVEljWMeta?.name,
    path: "users",
    meta: userszJpfjVEljWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93zRGmOYykm6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexFgYIMgzTArMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93gtiBMCn8zWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexrVPjn9efxJMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingswwsCsWX8lYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93lhU0yWHSh5Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93mavfE0pcPgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexR9fAHWd7wLMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signaturetw6BpqhJs3Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzviQS6NAe9YMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93QUy1L1SZqyMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93SdPXusSVZpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexiVWTfF0QbsMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93oGGeeH4CUlMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250527162257/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]